import { Modal, ModalOverlay, ModalContent, Box, Divider } from '@chakra-ui/react'
import { useEffect } from 'react'
import AboutContent from '../../pages/user/Content/aboutContent'
import AboutContentQuestions from '../../pages/user/Content/AboutContentQuestions'
import Questionnaire from '../../pages/user/Content/Questionnaire'

interface ExploreContentModalProps {
  isOpen: boolean
  onClose: () => void
  contentItem: any | null
}

const ExploreContentModal: React.FC<ExploreContentModalProps> = ({ isOpen, onClose, contentItem }) => {
  if (!contentItem) return null

  const usesFlowView = ['training', 'survey', 'learning'].includes(contentItem.content_type)

  useEffect(() => {
    if (!contentItem) {
      onClose()
    }
  }, [contentItem, onClose])

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxW="70vw" maxH="90vh" overflowY="auto" p={0}>
        <Box p={0} mb={6}>
          <AboutContent contentId={contentItem?.id} isModal={true} onClose={onClose} />
          <Divider />
          {usesFlowView ? (
            <Questionnaire isModal={true} modalId={contentItem?.id} onClose={onClose} />
          ) : (
            <AboutContentQuestions
              contentId={contentItem?.id}
              contentType={contentItem.content_type}
              isDraft={contentItem.is_draft}
              stopSidebar={false}
              isModal={true}
            />
          )}
        </Box>
      </ModalContent>
    </Modal>
  )
}

export default ExploreContentModal
